export const apiConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000/api/v1',
  sanctumBaseURL: import.meta.env.VITE_SANCTUM_BASE_URL ?? 'http://localhost:8000',
  timeout: 30_000,
} as const;
